export default __webpack_public_path__ + "static/media/blog1.faa708fd.png";